// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M2 4C2 2.9 2.9 2 4 2H12C13.1 2 14 2.9 14 4V12C14 13.1 13.1 14 12 14H4C2.9 14 2 13.1 2 12V4Z',
  'M6.85 5.55C6.85 6.27 6.27 6.85 5.55 6.85C4.83 6.85 4.25 6.27 4.25 5.55C4.25 4.83 4.83 4.25 5.55 4.25C6.27 4.25 6.85 4.83 6.85 5.55Z',
  'M3.35 13.83L8.83 8.35C9.48 7.7 10.52 7.7 11.17 8.35L14 11.18',
];
